/* CozyMelt — global.js
   Scroll helpers, sticky ATC visibility, smooth scroll
   -------------------------------------------------- */
(function () {
  'use strict';

  // Scroll a #bundle desde sticky ATC + sync pack picker demo→real
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-scroll-to-bundle]');
    if (trigger) {
      e.preventDefault();
      var target = document.getElementById('bundle');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var triggerNostos = e.target.closest('[data-scroll-to-bundle-nostos]');
    if (triggerNostos) {
      e.preventDefault();
      var targetN = document.getElementById('bundle-nostos');
      if (targetN) targetN.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var triggerLumito = e.target.closest('[data-scroll-to-bundle-lumito]');
    if (triggerLumito) {
      e.preventDefault();
      var targetL = document.getElementById('bundle-lumito');
      if (targetL) targetL.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var triggerTandem = e.target.closest('[data-scroll-to-bundle-tandem]');
    if (triggerTandem) {
      e.preventDefault();
      var targetT = document.getElementById('bundle-tandem');
      if (targetT) targetT.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      if (!gallery) return;
      var idx = thumb.getAttribute('data-thumb');
      gallery.querySelectorAll('[data-slide]').forEach(function (s) {
        s.classList.toggle('tandem-hero__slide--active', s.getAttribute('data-slide') === idx);
      });
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('tandem-hero__thumb--active', t === thumb);
      });
    }
  });

  // Tandem configurator: color label + addons togglables + precio dinámico
  function formatEUR(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  document.querySelectorAll('.tandem-configurator').forEach(function (cfg) {
    var basePrice = parseFloat(cfg.getAttribute('data-base-price')) || 37.99;
    var liveEls = cfg.querySelectorAll('[data-live-price], [data-live-price-cta]');

    function recalc() {
      var total = basePrice;
      cfg.querySelectorAll('input[name^="tcfg-upsell-"]:checked').forEach(function (inp) {
        total += parseFloat(inp.getAttribute('data-price')) || 0;
      });
      liveEls.forEach(function (el) { el.textContent = formatEUR(total); });
    }

    cfg.addEventListener('change', function (e) {
      // Color label dinámico
      if (e.target.matches('input[name="tcfg-color"]')) {
        var label = cfg.querySelector('[data-selected-color-label]');
        var swatch = e.target.closest('[data-color-label]');
        if (label && swatch) label.textContent = swatch.getAttribute('data-color-label');
        cfg.querySelectorAll('.tcfg__swatch').forEach(function (s) {
          var inp = s.querySelector('input');
          s.classList.toggle('tcfg__swatch--active', inp && inp.checked);
        });
        return;
      }
      // Upsells pagables → cambia active state + recalcula precio
      if (e.target.matches('input[name^="tcfg-upsell-"]')) {
        var addon = e.target.closest('.tcfg__addon');
        if (addon) addon.classList.toggle('tcfg__addon--active', e.target.checked);
        recalc();
      }
    });

    recalc();
  });

  // Sync demo pack picker a strip de precio sin producto real
  document.querySelectorAll('.bundle-card--fallback').forEach(function (card) {
    var isNostos = card.classList.contains('bundle-card--nostos');
    var isLumito = card.classList.contains('bundle-card--lumito');
    var isTandem = card.classList.contains('bundle-card--tandem');
    var PACK_META;
    if (isNostos) {
      PACK_META = {
        '1': { price: '59 €', compare: '89 €', save: 'Ahorras 30 €' },
        '2': { price: '99 €', compare: '178 €', save: 'Ahorras 79 €' },
        '3': { price: '139 €', compare: '267 €', save: 'Ahorras 128 €' }
      };
    } else if (isLumito) {
      PACK_META = {
        '1': { price: '19,99 €', compare: '29,99 €', save: 'Ahorras 10 €' },
        '2': { price: '32,99 €', compare: '59,98 €', save: 'Ahorras 26,99 €' },
        '3': { price: '44,99 €', compare: '89,97 €', save: 'Ahorras 44,98 €' }
      };
    } else if (isTandem) {
      // Tandem no usa PACK_META porque no tiene packs — precio base + addons
      return;
    } else if (false) {
      PACK_META = {
        '1': { price: '21,99 €', compare: '31,99 €', save: 'Ahorras 10 €' },
        '2': { price: '34,99 €', compare: '63,98 €', save: 'Ahorras 28,99 €' },
        '3': { price: '49,99 €', compare: '95,97 €', save: 'Ahorras 45,98 €' }
      };
    }
    var now = card.querySelector('[data-strip-now]');
    var compare = card.querySelector('[data-strip-compare]');
    var save = card.querySelector('[data-strip-save]');
    card.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="pack-demo"], input[name="pack-demo-nostos"], input[name="pack-demo-lumito"], input[name="pack-demo-tandem"]')) return;
      var val = e.target.value || '2u';
      var num = (val.match(/\d/) || ['2'])[0];
      var meta = PACK_META[num] || PACK_META['2'];
      if (now) now.textContent = meta.price;
      if (compare) compare.textContent = meta.compare;
      if (save) save.textContent = meta.save;
      card.querySelectorAll('.bundle-option').forEach(function (opt) {
        var input = opt.querySelector('input[name="pack-demo"]');
        opt.classList.toggle('bundle-option--active', input && input.checked);
      });
    });
  });

  // Sticky ATC visible solo tras scroll bajo hero
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  if (stickyAtc) {
    var hero = document.querySelector('.hero-funnel');
    var bundle = document.getElementById('bundle');
    stickyAtc.hidden = false;

    var threshold = hero ? hero.offsetTop + hero.offsetHeight : 400;

    function toggleSticky() {
      var y = window.scrollY;
      var bundleRect = bundle ? bundle.getBoundingClientRect() : null;
      var bundleOnScreen = bundleRect && bundleRect.top < window.innerHeight && bundleRect.bottom > 0;

      if (y > threshold && !bundleOnScreen) {
        stickyAtc.setAttribute('data-visible', '');
      } else {
        stickyAtc.removeAttribute('data-visible');
      }
    }
    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky, { passive: true });
    toggleSticky();
  }

  // Smooth scroll para anchor links
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (hash.length < 2) return;
    var target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
